export default "__VITE_ASSET__Dx_g99D8__"